import React from 'react';
import BreakdownSegment from './BreakdownSegment';
import MarcaCarousel from './MarcaCarousel';
import PaginationDots from './PaginationDots';
import { SEGMENT_CONFIGS } from './segmentsConfig';

const { segments, textSize } = SEGMENT_CONFIGS.expanded;

const StatCardExpanded = ({
  title,
  value,
  icon: Icon,
  color,
  calculationTooltip,
  detailedMarcasData,
  segmentValues,
  isAlertCard,
  canClick,
  handleClick,
  cardClasses,
  titleClasses,
  valueClasses,
  sortedMarcasEntries,
  totalPages,
  currentPage,
  handlePageChange,
}) => {
  const borderCls = isAlertCard ? 'border-white border-opacity-20' : 'border-gray-200';

  return (
    <div
      className={cardClasses}
      onClick={canClick ? handleClick : undefined}
      role={canClick ? 'button' : undefined}
      tabIndex={canClick ? 0 : undefined}
      onKeyPress={canClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); } : undefined}
    >
      {/* Header */}
      <div className="p-4 pb-2 flex justify-between items-start">
        <div className="flex-1">
          <p className={titleClasses}>{title}</p>
          <div className="flex items-center gap-2">
            <div className="flex items-baseline">
              <p className={valueClasses}>{value}</p>
              <p className={`text-xs ${isAlertCard ? 'text-white opacity-90' : 'text-gray-500'}`}>total</p>
            </div>

            {calculationTooltip && (
              <div className="group relative z-20" onClick={(e) => e.stopPropagation()}>
                <div className={`w-4 h-4 rounded-full ${isAlertCard ? 'bg-white/20' : 'bg-[#dde4f2]'} flex items-center justify-center cursor-help`}>
                  <span className={`${isAlertCard ? 'text-white' : 'text-[#1d2e61]'} font-bold text-[10px]`}>?</span>
                </div>
                <div className="absolute top-5 left-0 bg-gray-900/95 backdrop-blur-sm text-white p-2.5 rounded-lg text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-xl border border-gray-700">
                  {calculationTooltip.title && (
                    <div className="font-semibold mb-1.5 pb-1 border-b border-gray-700">{calculationTooltip.title}</div>
                  )}
                  <div className="space-y-1">
                    {calculationTooltip.items.map((item, idx) => (
                      <div key={idx} className="flex items-center justify-between gap-4">
                        <div className="flex items-center gap-1.5">
                          {item.icon && <item.icon className={`w-3 h-3 ${item.color || 'text-gray-400'}`} />}
                          <span className="text-gray-300">{item.label}:</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <span className="font-medium text-white">{item.value}</span>
                          {idx < calculationTooltip.items.length - 1 && (
                            <span className="text-gray-500 w-2 text-center">+</span>
                          )}
                        </div>
                      </div>
                    ))}
                    <div className="border-t border-gray-700 pt-1 mt-1 flex justify-between gap-4">
                      <span className="font-semibold text-gray-300">=</span>
                      <span className="font-bold text-white tracking-wide">{calculationTooltip.totalValue}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Breakdown section */}
      <div className="px-4 pb-3 flex-1 flex flex-col justify-end">
        <div className={`border-t pt-2 w-full ${borderCls}`}>
          {segments.map((seg) => (
            <BreakdownSegment
              key={seg.prop}
              dotColor={seg.dotColor}
              label={seg.label}
              value={segmentValues[seg.prop]}
              hideIfZero={seg.hideIfZero}
              accent={seg.accent}
              isAlertCard={isAlertCard}
              variant="expanded"
              textSize={textSize}
            />
          ))}

          <MarcaCarousel
            sortedMarcasEntries={sortedMarcasEntries}
            totalPages={totalPages}
            currentPage={currentPage}
            isAlertCard={isAlertCard}
            detailedMarcasData={detailedMarcasData}
            variant="expanded"
          />

          <PaginationDots
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            isAlertCard={isAlertCard}
          />
        </div>
      </div>
    </div>
  );
};

export default StatCardExpanded;
